var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "1000" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("event_note")]),
              _vm._v("\n      Asignar horario especial\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("clear")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "p-0" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { valid: _vm.valid },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.save()
                    }
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "sinMargen",
                                attrs: {
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  label: "Horario Especial",
                                  items: _vm.horarios_especiales,
                                  "item-text": "descripcion",
                                  "item-value": "id"
                                },
                                model: {
                                  value: _vm.form.id_horario_especial,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "id_horario_especial",
                                      $$v
                                    )
                                  },
                                  expression: "form.id_horario_especial"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _vm.form.id_horario_especial == "9"
                                ? _c("v-textarea", {
                                    staticClass: "sinMargen",
                                    attrs: {
                                      rows: "1",
                                      label: "Descripción",
                                      outline: "",
                                      clearable: "",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.form.descripcion_horario,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "descripcion_horario",
                                          $$v
                                        )
                                      },
                                      expression: "form.descripcion_horario"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "sinMargen",
                                attrs: {
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Fecha inicio",
                                  type: "date",
                                  outline: "",
                                  autofocus: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "sinMargen",
                                attrs: {
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Fecha fin",
                                  type: "date",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta", $$v)
                                  },
                                  expression: "form.fecha_hasta"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md12: "", xs12: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.ingresos_salidas_dias.length > 0,
                                    row: "",
                                    rules: [
                                      function(v) {
                                        if (v == null) {
                                          return "El campo es obligatorio."
                                        }
                                        return true
                                      }
                                    ]
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.asignaHorarioLaboralDefecto()
                                    }
                                  },
                                  model: {
                                    value: _vm.tipo_horario,
                                    callback: function($$v) {
                                      _vm.tipo_horario = $$v
                                    },
                                    expression: "tipo_horario"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Continuo", value: 1 }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "Discontinuo", value: 2 }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "Por turnos", value: 3 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h2", [_vm._v("HORARIOS")]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "", xs12: "" } },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        icon: "",
                                        color: "primary",
                                        dark: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.seleccionarTodo()
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("done")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Seleccionar todo")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        color: "primary",
                                        dark: "",
                                        icon: ""
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.deseleccionarTodo()
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("cancel")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Deseleccionar todo")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(this.dias, function(dias) {
                            return _c(
                              "div",
                              { key: dias.id, staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { md12: "", xs12: "" } },
                                  [
                                    _c(
                                      "v-tooltip",
                                      { attrs: { bottom: "" } },
                                      [
                                        !_vm.verifica(dias.id)
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  slot: "activator",
                                                  icon: ""
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.getId(dias.id)
                                                  }
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.getId(dias.id)
                                                  }
                                                },
                                                slot: "activator"
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v(
                                                    "check_box_outline_blank"
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.verifica(dias.id)
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  slot: "activator",
                                                  icon: ""
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.getId(dias.id)
                                                  }
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.getId(dias.id)
                                                  }
                                                },
                                                slot: "activator"
                                              },
                                              [_c("v-icon", [_vm._v("done")])],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(dias.valor2) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "pl-3 pr-3",
                              staticStyle: { "min-width": "100%" }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "", row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          label: "Hora ingreso",
                                          type: "time"
                                        },
                                        model: {
                                          value: _vm.form.hora_ingreso1,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "hora_ingreso1",
                                              $$v
                                            )
                                          },
                                          expression: "form.hora_ingreso1"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          label: "Tolerancia ingreso",
                                          type: "time"
                                        },
                                        model: {
                                          value: _vm.form.tolerancia1,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "tolerancia1",
                                              $$v
                                            )
                                          },
                                          expression: "form.tolerancia1"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          label: "Rango inicial Hora ingreso",
                                          type: "time"
                                        },
                                        model: {
                                          value: _vm.form.rango_ini1_am,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "rango_ini1_am",
                                              $$v
                                            )
                                          },
                                          expression: "form.rango_ini1_am"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          label: "Rango final Hora ingreso",
                                          type: "time"
                                        },
                                        model: {
                                          value: _vm.form.rango_fin1_am,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "rango_fin1_am",
                                              $$v
                                            )
                                          },
                                          expression: "form.rango_fin1_am"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          label: "Hora salida",
                                          type: "time"
                                        },
                                        model: {
                                          value: _vm.form.hora_fin1,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "hora_fin1", $$v)
                                          },
                                          expression: "form.hora_fin1"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          label: "Tolerancia salida",
                                          type: "time"
                                        },
                                        model: {
                                          value: _vm.form.tolerancia2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "tolerancia2",
                                              $$v
                                            )
                                          },
                                          expression: "form.tolerancia2"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          label: "Rango inicial Hora salida",
                                          type: "time"
                                        },
                                        model: {
                                          value: _vm.form.rango_ini2_am,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "rango_ini2_am",
                                              $$v
                                            )
                                          },
                                          expression: "form.rango_ini2_am"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          label: "Rango final Hora salida",
                                          type: "time"
                                        },
                                        model: {
                                          value: _vm.form.rango_fin2_am,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "rango_fin2_am",
                                              $$v
                                            )
                                          },
                                          expression: "form.rango_fin2_am"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  this.tipo_horario == 2
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs6: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              label: "Hora ingreso",
                                              type: "time"
                                            },
                                            model: {
                                              value: _vm.form.hora_ingreso2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "hora_ingreso2",
                                                  $$v
                                                )
                                              },
                                              expression: "form.hora_ingreso2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.tipo_horario == 2
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs6: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              label: "Tolerancia ingreso",
                                              type: "time"
                                            },
                                            model: {
                                              value: _vm.form.tolerancia3,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "tolerancia3",
                                                  $$v
                                                )
                                              },
                                              expression: "form.tolerancia3"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.tipo_horario == 2
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs6: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              label:
                                                "Rango inicial Hora ingreso - Tarde",
                                              type: "time"
                                            },
                                            model: {
                                              value: _vm.form.rango_ini1_pm,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "rango_ini1_pm",
                                                  $$v
                                                )
                                              },
                                              expression: "form.rango_ini1_pm"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.tipo_horario == 2
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs6: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              label:
                                                "Rango final Hora ingreso - Tarde",
                                              type: "time"
                                            },
                                            model: {
                                              value: _vm.form.rango_fin1_pm,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "rango_fin1_pm",
                                                  $$v
                                                )
                                              },
                                              expression: "form.rango_fin1_pm"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.tipo_horario == 2
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs6: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              label: "Hora salida",
                                              type: "time"
                                            },
                                            model: {
                                              value: _vm.form.hora_fin2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "hora_fin2",
                                                  $$v
                                                )
                                              },
                                              expression: "form.hora_fin2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.tipo_horario == 2
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs6: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              label: "Tolerancia salida",
                                              type: "time"
                                            },
                                            model: {
                                              value: _vm.form.tolerancia4,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "tolerancia4",
                                                  $$v
                                                )
                                              },
                                              expression: "form.tolerancia4"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.tipo_horario == 2
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs6: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              label:
                                                "Rango inicial Hora salida - Tarde",
                                              type: "time"
                                            },
                                            model: {
                                              value: _vm.form.rango_ini2_pm,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "rango_ini2_pm",
                                                  $$v
                                                )
                                              },
                                              expression: "form.rango_ini2_pm"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  this.tipo_horario == 2
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs6: "", md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.$validate([
                                                "required"
                                              ]),
                                              required: "",
                                              label:
                                                "Rango final Hora salida - Tarde",
                                              type: "time"
                                            },
                                            model: {
                                              value: _vm.form.rango_fin2_pm,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "rango_fin2_pm",
                                                  $$v
                                                )
                                              },
                                              expression: "form.rango_fin2_pm"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.tipo_horario == 3
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs12: "", md12: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "success",
                                                icon: "",
                                                title: "Adicionar"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.verificarHorario(
                                                    _vm.ingresos_salidas
                                                  )
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("add")])],
                                            1
                                          ),
                                          _vm._v(
                                            "\n                  Adicionar turno\n                "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.tipo_horario != 3
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs12: "", md12: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "success",
                                                icon: "",
                                                title: "Adicionar"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.verificarHorario(
                                                    _vm.ingresos_salidas
                                                  )
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("add")])],
                                            1
                                          ),
                                          _vm._v(
                                            "\n                  Adicionar horario\n                "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md12: "" } },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          items: _vm.ingresos_salidas_dias,
                                          "hide-actions": "",
                                          headers: _vm.headers_horario_temporal,
                                          "disable-initial-sort": true,
                                          "no-data-text":
                                            "No se registro ningun horario"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(props.item.dia) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          props.item.hora_inicio
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          props.item.hora_fin
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          color: "error",
                                                          icon: "",
                                                          title: "Eliminar"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.eliminarHorario(
                                                              props.item.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("delete")
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("cancel")]),
                  _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + "\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _vm.ingresos_salidas_dias.length > 0
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("save")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n      ")
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b74c622", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b74c622","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asignacion_horario/dialogs/AsignarHorarioEspecial.vue
// module id = null
// module chunks = 